export default __webpack_public_path__ + "static/media/003-about-noun_efficiency_3356873-1-1.fd2d25ca.webp";